import React from 'react'
import './Footer.scss'

const Footer = () => {
    return (
        <div className="instant-loans-footer">
            <div className="tnc-wrap">
                <div className="tnc">
                    <div>
                        <a href="/termsandconditions" target="_blank" rel="noopener noreferrer">Terms and conditions</a>
                        {" | "}
                        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    </div>
                    <div>©{new Date().getFullYear()} - NEOCAP | All rights reserved</div>
                </div>
                <div className="contact">
                    <div><a href="mailto:support.loans@swiggy.in">support.loans@swiggy.in</a></div>
                </div>
            </div>
        </div>
    )
}

export default Footer
